import React, { createContext } from "react";

export interface FormField {
    [field: string]: any;
}

interface FormContextProps {
    errors: FormField;
    inputPrefix: string;
    removeValue: (inputName: string) => void;
    setValue: (
        inputName: string,
        inputValue: string,
        previousValue: string,
        shouldValidate: boolean,
        visible: boolean,
    ) => void;
    started: FormField;
    values: FormField;
    visible: FormField;
}

const FormContext = createContext<FormContextProps>({
    inputPrefix: "",
    values: {},
    errors: {},
    visible: {},
    started: {},
    removeValue: () => undefined,
    setValue: () => undefined,
});

const { Consumer, Provider } = FormContext;

interface FormProviderProps {
    children: React.ReactNode;
    value: FormContextProps;
}

export const FormProvider: React.FC<FormProviderProps> = ({ children, value }) => (
    <Provider value={value}>{children}</Provider>
);

interface FormConsumerProps {
    children: (data: FormContextProps) => React.ReactNode;
}

export const FormConsumer: React.FC<FormConsumerProps> = ({ children }) => (
    <Consumer>
        {({ errors, inputPrefix, values, removeValue, setValue, started, visible }) =>
            children({ errors, inputPrefix, values, removeValue, setValue, started, visible })
        }
    </Consumer>
);
